// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"pdfmake":"3bd8c180fe27082c1552","canvg":"590be11cee39deff38c7","xlsx":"cf52b04ce1fdd7fd7e16"}[chunkId] + ".js";
};